// src/App.js
import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { StoreProvider } from '../contexts/StoreContext';
import { DisplayPreferencesProvider, useDisplayPreferences } from '../contexts/DisplayPreferencesContext';
import { HomePreferencesProvider } from '../contexts/HomePreferencesContext';

import NavigationBar from './NavigationBar';
import CatalogView from './CatalogView';
import ProductDetail from './ProductDetail';
import StoreDetail from './StoreDetail';
import Footer from './Footer';
import CategoryDetail from './CategoryDetail';
import MaintenanceView from './MaintenanceView';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppContent() {
  const { isUnderMaintenance, maintenanceMessage } = useDisplayPreferences();

  if (isUnderMaintenance) {
    return <MaintenanceView message={maintenanceMessage} />;
  }

  return (
    <div
      style={{
        padding: '0px',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
        overflowX: 'hidden',
      }}
    >
      <ScrollToTop />
      <NavigationBar />
      <div style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<CatalogView />} />
          <Route path="product/:slug" element={<ProductDetail />} />
          <Route path="category/:id" element={<CategoryDetail />} />
          <Route path="contact" element={<StoreDetail />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <StoreProvider>
      <DisplayPreferencesProvider>
        <HomePreferencesProvider>
          <AppContent />
        </HomePreferencesProvider>
      </DisplayPreferencesProvider>
    </StoreProvider>
  );
}
